import React from 'react';

export default React.createContext({
  profile: '',
  access_token: '',
  expires_at: '',
  tokenRenewalTimeout: null,
  pusherSocket: null,

  isAuthenticated: () => { },
  authenticate: (email, password) => { },
  hasRole: (role) => { },
  setSession: (authResult) => { },
  clearSession: () => { },
  logout: () => { },
  scheduleRenewal: () => { },
  anyRoles: (roles) => { }
});

